var React = require('react');

function CaretRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.52344 13.1406L8.02344 7.14062L1.52344 1.14062","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CaretRight.defaultProps = {"width":"10","height":"15","viewBox":"0 0 10 15","fill":"none"};

module.exports = CaretRight;

CaretRight.default = CaretRight;
